
import React, { useState, useRef, useEffect, useContext } from 'react';
import './header.css';
import { LiaSearchSolid } from "react-icons/lia";
import { AiOutlineShopping } from "react-icons/ai";
import { FaWhatsapp, FaRegComments } from 'react-icons/fa'; 
import { CartContext } from '../contexts/CartContext';
import { Link, useNavigate } from 'react-router-dom';
import toast from 'react-hot-toast';
import DialogContacts from '../components/dialogcontacts'; 


function formatPhoneNumber(phone) {
  if (!phone) return '';
  const cleaned = phone.replace(/\D/g, '');
  if (cleaned.length === 11 && cleaned.startsWith('7')) {
    return `+7 (${cleaned.slice(1, 4)}) ${cleaned.slice(4, 7)}-${cleaned.slice(7, 9)}-${cleaned.slice(9, 11)}`;
  }
  return phone;
}

function Header() {
  const [expanded, setExpanded] = useState(false);
  const timerRef = useRef(null);

  const [showCities, setShowCities] = useState(false);
  const [cityFilter, setCityFilter] = useState('');
  const cityInputRef = useRef(null);
  const [cities, setCities] = useState([]);
  const [chosenCity, setChosenCity] = useState('');

  
  const [apiData, setApiData] = useState(null);

  
  const [apiUrl, setApiUrl] = useState('');

  
  const { uniqueItemsCount } = useContext(CartContext);
  const navigate = useNavigate();

  
  const [isContactsOpen, setIsContactsOpen] = useState(false);

  
  const openContacts = () => setIsContactsOpen(true);
  const closeContacts = () => setIsContactsOpen(false);

  
  useEffect(() => {
    fetch('/templates/api.txt')
      .then((res) => res.text())
      .then((data) => {
        setApiUrl(data.trim());
      })
      .catch((err) => console.error('Ошибка загрузки API URL:', err));
  }, []);

  
  useEffect(() => {
    if (!apiUrl) return;
    fetch(`${apiUrl}api/info`)
      .then((res) => res.json())
      .then((data) => {
        setApiData(data);
      })
      .catch((err) => console.error('Ошибка загрузки /api/info:', err));
  }, [apiUrl]);

  
  useEffect(() => {
    const fetchCities = async () => {
      try {
        const savedCity = localStorage.getItem('chosenCity');
        const response = await fetch('https://api.hh.ru/areas');
        const data = await response.json();
        const russia = data.find(country => country.id === '113');
        if (!russia) return;

        const getAllCities = (areas) => {
          let result = [];
          for (const area of areas) {
            if (area.areas && area.areas.length > 0) {
              result = result.concat(getAllCities(area.areas));
            } else {
              if (area.name) {
                result.push(area.name);
              }
            }
          }
          return result;
        };

        const allCities = getAllCities(russia.areas);
        allCities.sort();
        setCities(allCities);

        if (savedCity && allCities.includes(savedCity)) {
          setChosenCity(savedCity);
          setCityFilter(savedCity);
        } else if (savedCity) {
          localStorage.removeItem('chosenCity');
        }
      } catch (e) {
        console.error(e);
      }
    };

    fetchCities();
  }, []);

  const filteredCities = cities.filter(city =>
    city.toLowerCase().startsWith(cityFilter.toLowerCase())
  );

  const handleMouseEnter = () => {
    if (!chosenCity) {
      clearTimeout(timerRef.current);
      setExpanded(true);
    }
  };

  const handleMouseLeave = () => {
    if (!chosenCity) {
      clearTimeout(timerRef.current);
      timerRef.current = setTimeout(() => {
        setExpanded(false);
        setShowCities(false);
      }, 4000);
    }
  };

  const handleFocus = () => {
    setShowCities(true);
  };

  const handleBlur = () => {
    setTimeout(() => {
      if (document.activeElement !== cityInputRef.current) {
        setShowCities(false);
      }
    }, 200);
  };

  const handleCitySelect = (city) => {
    setCityFilter(city);
    setChosenCity(city);
    setShowCities(false);
    setExpanded(false);
    localStorage.setItem('chosenCity', city);
    toast.success(`Вы выбрали город: ${city}`);
  };

  const handleRegionClick = () => {
    if (chosenCity) {
      setExpanded(true);
      setTimeout(() => {
        cityInputRef.current?.focus();
      }, 100);
    }
  };

  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const handleBurgerClick = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  
  useEffect(() => {
    return () => {
      clearTimeout(timerRef.current);
    };
  }, []);

  
  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === 'Escape' && isMenuOpen) {
        setIsMenuOpen(false);
      }
    };
    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [isMenuOpen]);

  
  useEffect(() => {
    if (isMenuOpen) {
      document.body.classList.add('no-scroll');
    } else {
      document.body.classList.remove('no-scroll');
    }
  }, [isMenuOpen]);

  const getBadgeCount = () => {
    if (uniqueItemsCount > 9) return '9+';
    return uniqueItemsCount;
  };

  const displayedPhone = apiData ? formatPhoneNumber(apiData.phone) : '+7 (495) 300-74-41';
  const displayedWhatsapp = apiData ? formatPhoneNumber(apiData.whatsapp) : '+7 (495) 300-74-41';
  const whatsappLink = apiData ? `https://wa.me/${apiData.whatsapp}` : '#';

  const logoText = apiData ? apiData.title : '';

  return (
    <header className="header">
      {/* Мобильный хедер */}
      <div className="mobile-header">
        <div className="mobile-left">
          <div
            className={`burger-menu ${isMenuOpen ? 'active' : ''}`}
            onClick={handleBurgerClick}
            aria-label="Меню"
            role="button"
            tabIndex="0"
            onKeyPress={(e) => { if (e.key === 'Enter') handleBurgerClick(); }}
          >
            <span className="bar bar1"></span>
            <span className="bar bar2"></span>
            <span className="bar bar3"></span>
          </div>

          {/* Кнопка выбора региона */}
          <div
            className={`region-wrapper ${expanded ? 'expanded' : ''}`}
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}
            onClick={handleRegionClick}
          >
            <div className="region-content">
              {!expanded && (
                <div className="region-button">
                  <span className="region-text">{chosenCity || 'Регион'}</span>
                  <LiaSearchSolid className="region-icon" />
                </div>
              )}
              {expanded && (
                <div className="region-input-wrapper">
                  <input
                    type="text"
                    className="region-input"
                    placeholder="Поиск региона"
                    onFocus={handleFocus}
                    onBlur={handleBlur}
                    onChange={(e) => setCityFilter(e.target.value)}
                    ref={cityInputRef}
                    value={cityFilter}
                  />
                  <LiaSearchSolid className="region-icon-input" />
                </div>
              )}
              {showCities && filteredCities.length > 0 && (
                <div className="cities-dropdown" tabIndex="0">
                  {filteredCities.map((city, idx) => (
                    <button
                      type="button"
                      key={idx}
                      className="city-item"
                      onMouseDown={() => handleCitySelect(city)}
                    >
                      {city}
                    </button>
                  ))}
                </div>
              )}
            </div>
          </div>
        </div>

        <Link to="/" className="header-logo-mobile">
          <span className="logo-text-mobile">{logoText}</span>
        </Link>

        <div className="header-buttons-mobile">
          <Link to="/catalog" className="icon-button" aria-label="Поиск">
            <LiaSearchSolid className="icon-24" />
          </Link>
          <Link
            to="/cart"
            className="icon-button cart-icon-mobile"
            aria-label="Корзина"
          >
            <AiOutlineShopping className="icon-24" />
            {uniqueItemsCount > 0 && (
              <span className="cart-badge">
                {getBadgeCount()}
              </span>
            )}
          </Link>
          {/* Добавляем кнопку "Отзывы" для мобильной версии */}
          <Link
            to="/reviews"
            className="icon-button reviews-icon-mobile"
            aria-label="Отзывы"
          >
            <FaRegComments className="icon-24" />
          </Link>
        </div>
      </div>

      {isMenuOpen && <div className="menu-overlay" onClick={handleBurgerClick} aria-hidden="true"></div>}

      {/* Боковое меню */}
      <nav className={`side-menu ${isMenuOpen ? 'open' : ''}`} aria-hidden={!isMenuOpen}>
        <div className="side-menu-content">
          <button className="close-button" onClick={handleBurgerClick} aria-label="Закрыть меню">
            &times;
          </button>

          <div className="side-menu-left">
            <Link
              to="/catalog"
              className="side-menu-link"
              onClick={() => setIsMenuOpen(false)}
            >
              Сигареты
            </Link>
            <Link
              to="/about-us"
              className="side-menu-link"
              onClick={() => setIsMenuOpen(false)}
            >
              О нас
            </Link>
            <Link
              to="/help"
              className="side-menu-link"
              onClick={() => setIsMenuOpen(false)}
            >
              Помощь
            </Link>
            <Link
              to="/purchase-and-payment"
              className="side-menu-link"
              onClick={() => setIsMenuOpen(false)}
            >
              Покупка и оплата
            </Link>
            {/* Добавляем кнопку "Отзывы" в боковое меню */}
            <Link
              to="/reviews"
              className="side-menu-link"
              onClick={() => setIsMenuOpen(false)}
            >
              Отзывы
            </Link>
            <Link
              to="/blogs"
              className="side-menu-link"
              onClick={() => setIsMenuOpen(false)}
            >
              Блог
            </Link>
          </div>
          

          <div className="side-menu-right">
            <Link
              to="/cart"
              className="side-menu-cart-link"
              onClick={() => setIsMenuOpen(false)}
              aria-label="Корзина"
            >
              <AiOutlineShopping className="side-menu-cart-icon" />
              {uniqueItemsCount > 0 && (
                <span className="cart-badge side-menu-cart-badge">
                  {getBadgeCount()}
                </span>
              )}
            </Link>
            {/* Удалено: Телефон как текст */}
            <p className="contact-info">info@cigars-shop.ru</p>
            <p className="contact-info">г. Москва, ул. Молостовых, д. 3Б</p>
          </div>
        </div>
      </nav>

      {/* Десктопная версия хедера */}
      <div className="header-content">
        <div className="header-container">
          <img
            src="/templates/head-topic.jpg"
            alt="Иконка"
            className="header-icon"
            width="20"
            height="26"
          />
          <div className="header-text">
            <p className="header-title">Онлайн каталог табачных изделий.</p>
            <p className="header-subtitle">
              Откройте для себя мир качественных сигарет: проверенные бренды, широкий 
              выбор и лучшие предложения для вашего удовольствия.
            </p>
          </div>
        </div>

        <Link to="/" className="header-logo">
          <span className="logo-text-desktop">{logoText}</span>
        </Link>

        <div className="header-right">
          <div className="header-links-left-container">
            <div className="header-links-row">
              {/* Кнопка "Контакты" с обработчиком клика */}
              <button className="contact-link" onClick={openContacts} aria-label="Открыть контакты">
                Контакты
              </button>
              <span className="whatsapp-link">
                <span className="whatsapp-text">Напишите нам</span>
                <span className="whatsapp-icon">
                  <a
                    href={whatsappLink}
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{ color: 'inherit', textDecoration: 'none' }}
                  >
                    <FaWhatsapp className="fa-whatsapp-icon" />
                  </a>
                </span>
              </span>
            </div>
          </div>

          <div className="header-contact-wrapper">
            <div className="header-contact">
              <span className="contact-circle"></span>
              Часы работы, Пн-Вс 10:00-23:00 по Мск
            </div>
            {/* Удалено: телефон как текст */}
            <div className="header-secondary">
              {/* Removed the phone number link */}
              <span className="contact-button">info@cigars-shop.ru</span>
              <span className="contact-address">Доставка по России за 2–5 дней.</span>
            </div>
          </div>
        </div>
      </div>

      <div className="header-bottom">
        <div className="header-bottom-left">
          <div
            className={`region-wrapper ${expanded ? 'expanded' : ''}`}
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}
            onClick={handleRegionClick}
          >
            <div className="region-content">
              {!expanded && (
                <div className="region-button">
                  <span className="region-text">{chosenCity || 'Регион'}</span>
                  <LiaSearchSolid className="region-icon" />
                </div>
              )}
              {expanded && (
                <div className="region-input-wrapper">
                  <input
                    type="text"
                    className="region-input"
                    placeholder="Поиск региона"
                    onFocus={handleFocus}
                    onBlur={handleBlur}
                    onChange={(e) => setCityFilter(e.target.value)}
                    ref={cityInputRef}
                    value={cityFilter}
                  />
                  <LiaSearchSolid className="region-icon-input" />
                </div>
              )}
              {showCities && filteredCities.length > 0 && (
                <div className="cities-dropdown" tabIndex="0">
                  {filteredCities.map((city, idx) => (
                    <button
                      type="button"
                      key={idx}
                      className="city-item"
                      onMouseDown={() => handleCitySelect(city)}
                    >
                      {city}
                    </button>
                  ))}
                </div>
              )}
            </div>
          </div>

          <Link to="/catalog" className="bottom-link">Сигареты</Link>
          <Link to="/about-us" className="bottom-link">О нас</Link>
          <Link to="/help" className="bottom-link">Помощь</Link>
          <Link to="/purchase-and-payment" className="bottom-link">Покупка и оплата</Link>
          {/* Добавляем кнопку "Отзывы" для десктопной версии */}
          <Link to="/reviews" className="bottom-link">Отзывы</Link>
          <Link to="/blogs" className="bottom-link">Блог</Link>
          {/* Удалено: выпадающий список для брендов в десктопной версии */}
        </div>
        <div className="header-bottom-right">
          <Link to="/catalog" className="icon-button" aria-label="Поиск">
            <LiaSearchSolid className="icon-24" />
          </Link>
          <Link
            to="/cart"
            className="icon-button cart-icon-desktop"
            aria-label="Корзина"
          >
            <AiOutlineShopping className="icon-24" />
            {uniqueItemsCount > 0 && (
              <span className="cart-badge">
                {getBadgeCount()}
              </span>
            )}
          </Link>
          {/* Измененная кнопка "Заказать звонок" */}
          <a
            className="call-button"
            href={whatsappLink}
            target="_blank"
            rel="noopener noreferrer"
          >
            Заказать звонок
          </a>
          {/* Удаляем дублирующую кнопку "Отзывы" из десктопной правой части */}
          {





}
        </div>
      </div>

      {/* Включение компонента DialogContacts */}
      <DialogContacts isOpen={isContactsOpen} onClose={closeContacts} />
    </header>
  );
}

export default Header;
